var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, CustomElement, COMPONENT_STATE, html, Watch, Event, directive, nothing, State, PropertyPart } from '@sick-davinci/ce-decorators';
import { style } from './NumericField.style';
import { Button } from '../button/Button';
/** Check if numeric field is used on a SICK Industry Display (SID)
 *  If so, we are running on a chrome in version 55 which has severe pointerevent-bugs
 *
 *  see https://bugs.chromium.org/p/chromium/issues/detail?id=689158
 */

const isSid = window.navigator.userAgent === 'SOPASair Browser';
const useTouchEvents = 'onpointerdown' in document.documentElement || 'ontouchstart' in document.documentElement;
const set = new WeakMap(); // WeakSet needs Polyfill, weak map is built in

const pressEventType = isSid // creepy hack for handling chrome 55 bug
? 'touchstart' : 'onpointerdown' in document ? 'pointerdown' : 'ontouchstart' in document ? 'touchstart' : 'mousedown';
const releaseEventType = isSid // creepy hack for handling chrome 55 bug
? 'touchend' : 'onpointerdown' in document ? 'pointerup' : 'ontouchstart' in document ? 'touchend' : 'mouseup';
const cancelEventType = isSid // creepy hack for handling chrome 55 bug
? 'touchend' : 'onpointerdown' in document ? 'pointercancel' : 'ontouchstart' in document ? 'touchend' : 'mouseleave';
const pressEventDirective = directive(callback => part => {
  if (set.has(part)) {
    return;
  } else {
    part.element.addEventListener(pressEventType, callback);
    set.set(part, true);
  }
});
/**
 * Ensure lit-html gets informed about updated value
 *
 * (see https://deagxjira.sickcn.net/jira/browse/DAVIBE-494)
 */

const forceValue = directive(value => part => {
  if (part instanceof PropertyPart) {
    const name = part.committer.name;
    part.committer.element[name] = value; // tslint:disable-line
  } else {
    const name = part.committer.name;
    part.committer.element.setAttribute(name, value + '');
  }
});
/**
 * A `davinci-numeric-field` is a text field that only allows to input numbers.
 * The value can also be changed using up-/down-buttons.
 *
 * @example
 * ```html
 * <davinci-numeric-field value="50"></davinci-numeric-field>
 * ```
 * @deprecated Please use NumberInput instead.
 */

export let NumericField = (_dec = Component({
  style: [style],
  tag: 'davinci-numeric-field',
  dependencies: [Button]
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Number), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Number), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", Boolean), _dec12 = Prop({
  type: String
}), _dec13 = Reflect.metadata("design:type", String), _dec14 = Prop({
  type: String
}), _dec15 = Reflect.metadata("design:type", String), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", String), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", String), _dec20 = Prop(), _dec21 = Reflect.metadata("design:type", Boolean), _dec22 = Event(), _dec23 = Reflect.metadata("design:type", Object), _dec24 = Event(), _dec25 = Reflect.metadata("design:type", Object), _dec26 = State(), _dec27 = Prop({
  reflectAsAttribute: false
}), _dec28 = Reflect.metadata("design:type", Number), _dec29 = Watch('min'), _dec30 = Reflect.metadata("design:paramtypes", [Number, Number]), _dec31 = Watch('max'), _dec32 = Reflect.metadata("design:paramtypes", [Number, Number]), _dec33 = Watch('groupSeparator'), _dec34 = Watch('decimalSeparator'), _dec35 = Watch('min'), _dec36 = Watch('max'), _dec37 = Watch('alignToTicks'), _dec38 = Reflect.metadata("design:paramtypes", []), _dec39 = Watch('formatPattern'), _dec40 = Reflect.metadata("design:paramtypes", []), _dec41 = Watch('disabled'), _dec42 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec(_class = (_class2 = class NumericField extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "type", _descriptor, this);

    _initializerDefineProperty(this, "min", _descriptor2, this);

    _initializerDefineProperty(this, "max", _descriptor3, this);

    _initializerDefineProperty(this, "ticks", _descriptor4, this);

    _initializerDefineProperty(this, "alignToTicks", _descriptor5, this);

    _initializerDefineProperty(this, "groupSeparator", _descriptor6, this);

    _initializerDefineProperty(this, "decimalSeparator", _descriptor7, this);

    _initializerDefineProperty(this, "formatPattern", _descriptor8, this);

    _initializerDefineProperty(this, "unit", _descriptor9, this);

    _initializerDefineProperty(this, "disabled", _descriptor10, this);

    _initializerDefineProperty(this, "change", _descriptor11, this);

    _initializerDefineProperty(this, "input", _descriptor12, this);

    _initializerDefineProperty(this, "_value", _descriptor13, this);

    _defineProperty(this, "_direction", 1);

    _defineProperty(this, "_incrementInterval", null);

    _defineProperty(this, "_holdTimeout", null);

    _defineProperty(this, "_changeTimeout", null);

    _defineProperty(this, "_groupDigits", false);

    _defineProperty(this, "_decimals", 0);

    _defineProperty(this, "onInput", event => {
      event.stopPropagation();

      this._emitInput(event.currentTarget.value);
    });

    _defineProperty(this, "onChange", () => {
      if (this._isSanitizableNumber(this._elementInput.value)) {
        this._value = this._round(this._sanitizeInputValue(this._elementInput.value, this.decimalSeparator));

        this._filterMinMax();
      }

      this._elementInput.value = this._formatNumber(this._value);
      this.change.emit(this._value);
    });

    _defineProperty(this, "keyboardDownEvent", event => {
      switch (event.key) {
        case 'ArrowDown':
        case 'Down':
          // IE/Edge
          if (this.type !== 'bare') {
            this._setButtonTo('.decrease', true);
          }

          this._direction = -1;

          this._applyTick();

          this._emitInput(this._value);

          event.preventDefault();
          break;

        case 'ArrowUp':
        case 'Up':
          // IE/Edge
          if (this.type !== 'bare') {
            this._setButtonTo('.increase', true);
          }

          this._direction = 1;

          this._applyTick();

          this._emitInput(this._value);

          event.preventDefault();
          break;

        default:
          break;
      }
    });

    _defineProperty(this, "keyboardUpEvent", event => {
      switch (event.key) {
        case 'ArrowDown':
        case 'Down':
          // IE/Edge
          if (this.type !== 'bare') {
            this._setButtonTo('.decrease', false);
          }

          this.change.emit(this._value);
          event.preventDefault();
          break;

        case 'ArrowUp':
        case 'Up':
          // IE/Edge
          if (this.type !== 'bare') {
            this._setButtonTo('.increase', false);
          }

          this.change.emit(this._value);
          event.preventDefault();
          break;

        default:
          break;
      }
    });

    _defineProperty(this, "onClickIncrease", e => {
      if (e.button !== 2) {
        this._direction = 1;
        this.spinStartEventListener();
      }
    });

    _defineProperty(this, "onClickDecrease", e => {
      if (e.button !== 2) {
        this._direction = -1;
        this.spinStartEventListener();
      }
    });

    _defineProperty(this, "spinStartEventListener", () => {
      if (this._changeTimeout !== null) {
        window.clearTimeout(this._changeTimeout);
        this._changeTimeout = null;
      }

      document.addEventListener(releaseEventType, this.spinEndListener);

      if (useTouchEvents) {
        document.addEventListener(cancelEventType, this.spinEndListener);
      }

      this._applyTick();

      this._emitInput(this._value);

      this._holdTimeout = window.setTimeout(() => {
        this._incrementInterval = window.setInterval(() => {
          this._applyTick();

          this._emitInput(this._value);
        }, isSid ? 100 : 25); // The SID is overwhelmed by a shorter interval
      }, 500);
    });

    _defineProperty(this, "spinEndListener", () => {
      document.removeEventListener(releaseEventType, this.spinEndListener);

      if (useTouchEvents) {
        document.removeEventListener(cancelEventType, this.spinEndListener);
      }

      window.clearTimeout(this._holdTimeout);
      this._holdTimeout = null;
      window.clearInterval(this._incrementInterval);
      this._incrementInterval = null;
      this._changeTimeout = window.setTimeout(() => {
        this._changeTimeout = null;
        this.change.emit(this._value);

        this._setButtonTo('.decrease', false);
      }, 500);
    });
  }

  /**
   * Get the value of the numeric field.
   */
  get value() {
    return this._value;
  }
  /**
   * Actual content of the numeric field.
   * Entering illegal characters (others than digits, groupSeparators and decimalSeparators) resets the value to its last valid state
   */


  set value(value) {
    // sanitizing the input value on setting (rerendering etc. is essential to prevent illegal inputs)
    this._value = this._roundToClosestStep(value ? this._sanitizeInputValue(value.toString(), '.') : 0);
  }

  render() {
    return html`
    <div class="wrapper">
      ${this.type === 'bare' ? html`` : html`<davinci-button type="${this.type}" class="decrease" icon="content/remove"
                ?disabled="${this.isMinDisabled()}" @="${pressEventDirective(this.onClickDecrease)}"></davinci-button>`}
      <input
        class="input"
        type="text"
        size="1"
        .value="${forceValue(this._formatNumber(this._value))}"
        title="${forceValue(this._formatNumber(this._value))}"
        @change=${this.onChange}
        @input="${this.onInput}"
        >
      </input>
      ${this.type === 'bare' ? html`` : html`<davinci-button type="${this.type}" class="increase" icon="content/add"
                ?disabled="${this.isMaxDisabled()}" @="${pressEventDirective(this.onClickIncrease)}"></davinci-button>`}
      ${this.renderUnit()}
    </div>`;
  }

  componentConnected() {
    this.addEventListener('keydown', this.keyboardDownEvent);
    this.addEventListener('keyup', this.keyboardUpEvent);
    this.disabledChangeHandler(this.disabled, this.disabled);
  }

  componentDisconnected() {
    this.removeEventListener('keydown', this.keyboardDownEvent);
    this.removeEventListener('keyup', this.keyboardUpEvent);
    document.removeEventListener(releaseEventType, this.spinEndListener);
    document.removeEventListener(cancelEventType, this.spinEndListener);
  } // TODO: filterMinmax should be done in the setter (setting programmatically) and when commiting a value from the change event


  componentWillRender() {
    this._filterMinMax();
  }

  componentFirstRender() {
    this._elementInput = this.shadowRoot.querySelector('input');

    this._analyzeFormatPattern();

    this._filterMinMax(); // TODO: filterMinmax should be done in the setter (setting programmatically) and when commiting a value from the change event


    this._elementInput.value = this._formatNumber(this._value); // Otherwise the calculated width has no effect

    this.scheduleRender();
  }

  updateMin(_, newValue) {
    if (newValue < Number.MIN_SAFE_INTEGER) {
      this.min = Number.MIN_SAFE_INTEGER;
    }
  }

  updateMax(_, newValue) {
    if (newValue > Number.MAX_SAFE_INTEGER) {
      this.max = Number.MAX_SAFE_INTEGER;
    }
  }

  updateElement() {
    this._updateElement();
  }

  updateFormatPattern() {
    this._analyzeFormatPattern();

    this._updateElement();
  }

  disabledChangeHandler(_, newValue) {
    if (this._componentState !== COMPONENT_STATE.INIT) {
      // avoid setting illegal attribute set during construction
      if (!newValue) {
        // with this code the focused slider has a blue highlighting-box
        this.setAttribute('tabindex', '0');
      }
    }
  }

  isMinDisabled() {
    return this.disabled || this._value <= this.min ? true : false;
  }

  isMaxDisabled() {
    return this.disabled || this._value >= this.max ? true : false;
  }

  _emitInput(value) {
    if (typeof value === 'number') {
      value = this._exponentialToFixed(value.toString(), '.');
    }

    this.input.emit(value);
  }

  renderUnit() {
    return this.unit !== undefined ? html`<span class="unit">${this.unit}</span>` : nothing;
  }

  _updateElement() {
    if (this._elementInput) {
      this._filterMinMax();

      this._elementInput.value = this._formatNumber(this._value);
    }

    this.scheduleRender(true);
  }

  _analyzeFormatPattern() {
    if (!this.formatPattern) {
      return;
    } // check if illegal signs are part of the pattern


    if (/[^\d\.,\-\+#]/.test(this.formatPattern)) {
      console.warn('Illegal characters in format pattern. Format pattern is ignored'); // tslint:disable-line: no-console

      return;
    }

    const result = this.formatPattern.match(/[^\d\-\+#]/g); // Treat the right most symbol as decimal

    let decimalSeparator;
    let decimals = 0;

    if (result) {
      decimalSeparator = result[result.length - 1]; // Split the decimal for the format string if any.

      const patternArray = this.formatPattern.split(decimalSeparator);
      decimals = patternArray[patternArray.length - 1].length;
    }

    let groupDigits = false; // Treat the left most symbol as group separator

    if (result && result[1] && result[0]) {
      groupDigits = !!result[0];
    }

    this._decimals = decimals;
    this._groupDigits = groupDigits;
  }

  _isSanitizableNumber(value) {
    // add separators to matcher
    const digits = value.match(/-?[\d]/g);
    let illegalCharacterCheck = value.replace(/-?\d/g, ''); // accept digits

    illegalCharacterCheck = illegalCharacterCheck.replace(new RegExp(this.groupSeparator, 'g'), ''); // accept groupSeparator signs

    illegalCharacterCheck = illegalCharacterCheck.replace(new RegExp('\\' + this.decimalSeparator, 'g'), ''); // accept decimalSeparator signs

    return !!(digits && digits.length && illegalCharacterCheck.length === 0);
  }

  _sanitizeInputValue(value = 0, decimalSeparator) {
    let {
      negative,
      integerString,
      decimalsString
    } = this._getValueSegments(value.toString(), decimalSeparator); // tslint:disable-line: prefer-const


    if (this._decimals) {
      decimalsString = decimalsString.slice(0, this._decimals);
    }

    let result = Number([negative ? '-' : '', integerString, '.', decimalsString || '0'].join(''));
    result = result > Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : result;
    result = result < Number.MIN_SAFE_INTEGER ? Number.MIN_SAFE_INTEGER : result;
    return result;
  }

  _getValueSegments(value, decimalSeparator) {
    value = this._exponentialToFixed(value, decimalSeparator);
    const negative = value.charAt(0) === '-';
    const parts = value.split(decimalSeparator); // split string by decimalSeparator

    while (parts.length < 2) {
      parts.push('');
    }

    let integerString = parts.slice(0, parts.length - 1).join(''); // concat all parts before the last decimalSeparator

    integerString = (integerString.match(/[\d]/g) || []).join(''); // remove non-digits

    let decimalsString = parts[parts.length - 1] || '0'; // use only string after last decimalSeparator

    decimalsString = (decimalsString.match(/[\d]/g) || []).join(''); // remove non-digits

    return {
      negative,
      integerString,
      decimalsString
    };
  }
  /**
   * Tests a string for being a number in exponential notation with negative exponent and converts it to fixed
   *  point notation. If the passed in value is not a number in exponential notation, the original value is returned.
   * @param value string representing a number
   * @returns string number in fixed point notation or original value
   */


  _exponentialToFixed(value, decimalSeparator = '.') {
    if (value.match(/\d?\.?\d*e-\d+/)) {
      let parts = value.split('e-');
      const exponent = parseInt(parts[1], 10);
      parts = parts[0].split('.');
      const digits = parts.length > 1 ? parts[1].length : 0;
      value = parseFloat(value).toFixed(exponent + digits).split('.').join(decimalSeparator);
    }

    return value;
  }

  _formatNumber(value = 0) {
    let {
      negative,
      integerString,
      decimalsString
    } = this._getValueSegments(value.toString(), '.'); // tslint:disable-line: prefer-const


    if (this._groupDigits) {
      const digitGroups = integerString.match(/.{1,3}(?=(.{3})+(?!.))|.{1,3}$/g); // split string by groups of 3 digits "from the end"

      integerString = digitGroups.join(this.groupSeparator); // (re)join with groupSeperator
    }

    if (this._decimals) {
      decimalsString = decimalsString.slice(0, this._decimals); // get max the number of decimals, we want

      decimalsString = decimalsString.padEnd(this._decimals, '0'); // fill to the desired number of decimals with 0s
    }

    return [negative ? '-' : '', integerString, this._decimals ? this.decimalSeparator : '', this._decimals ? decimalsString : ''].join('');
  }

  _applyTick() {
    const newValue = this._value + this.ticks * this._direction;
    this._value = Number(newValue.toFixed(this._decimals + 1)); // avoid JS rounding errors round the last number at the decimal position

    this._filterMinMax();

    this._elementInput.value = this._formatNumber(this._value);
  } // TODO Format Pattern evaluation should take care of rounding etc


  _round(value) {
    if (!this._decimals) {
      value = Math.round(value);
    }

    return value;
  }

  _filterMinMax() {
    let value = this._value || 0;
    value = this._roundToClosestStep(value);

    if (this.min !== null && value < this.min) {
      value = this.min;
    } else if (this.max !== null && value > this.max) {
      value = this.max;
    }

    this._value = value;
  }

  _setButtonTo(selector, selected) {
    if (selected) {
      this.shadowRoot.querySelector(selector).setAttribute('toggle', 'true');
      this.shadowRoot.querySelector(selector).setAttribute('selected', 'true');
    } else {
      this.shadowRoot.querySelector(selector).removeAttribute('toggle');
      this.shadowRoot.querySelector(selector).removeAttribute('selected');
    }
  }

  _roundToClosestStep(value) {
    if (typeof this.min === 'number' && typeof this.ticks === 'number' && this.alignToTicks) {
      return Math.round((value - this.min) / this.ticks) * this.ticks + this.min;
    } else {
      return value;
    }
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'outline';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "min", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return -1.7976931348623157e+308;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "max", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1.7976931348623157e+308;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "ticks", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "alignToTicks", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "groupSeparator", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ',';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "decimalSeparator", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '.';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "formatPattern", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '0';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "unit", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec24, _dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "_value", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "value", [_dec27, _dec28], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateMin", [_dec29, _dec30], Object.getOwnPropertyDescriptor(_class2.prototype, "updateMin"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateMax", [_dec31, _dec32], Object.getOwnPropertyDescriptor(_class2.prototype, "updateMax"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateElement", [_dec33, _dec34, _dec35, _dec36, _dec37, _dec38], Object.getOwnPropertyDescriptor(_class2.prototype, "updateElement"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateFormatPattern", [_dec39, _dec40], Object.getOwnPropertyDescriptor(_class2.prototype, "updateFormatPattern"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disabledChangeHandler", [_dec41, _dec42], Object.getOwnPropertyDescriptor(_class2.prototype, "disabledChangeHandler"), _class2.prototype)), _class2)) || _class);
